import * as agentApi from '@/api/agents'
import {
  FETCH_AGENTS,
  FETCH_AGENTS_SUCCESS,
  FETCH_AGENTS_FAILURE,
  FETCH_AGENT,
  FETCH_AGENT_SUCCESS,
  FETCH_AGENT_FAILURE,
  FETCH_AGENTS_BY_OBSERVATIONS,
  FETCH_AGENTS_BY_OBSERVATIONS_SUCCESS,
  FETCH_AGENTS_BY_OBSERVATIONS_FAILURE,
  CLEAR_SELECTED_AGENT
} from '../mutation-types'

const actions = {
  fetchAgents: async ({ commit }) => {
    try {
      commit(FETCH_AGENTS)
      const response = await agentApi.fetchAgents()
      commit(FETCH_AGENTS_SUCCESS, response.data)
    } catch (error) {
      console.error(error)
      commit(FETCH_AGENTS_FAILURE, error)
    }
  },
  fetchAgentsByObservations: async ({ commit }, observations) => {
    try {
      commit(FETCH_AGENTS_BY_OBSERVATIONS)
      const response = await agentApi.searchAgents(observations)
      commit(FETCH_AGENTS_BY_OBSERVATIONS_SUCCESS, response.data)
    } catch (error) {
      console.error(error)
      commit(FETCH_AGENTS_BY_OBSERVATIONS_FAILURE, error)
    }
  },
  fetchAgent: async ({ commit }, agentSlug) => {
    try {
      commit(CLEAR_SELECTED_AGENT)
      commit(FETCH_AGENT)
      const response = await agentApi.fetchAgentBySlug(agentSlug)
      commit(FETCH_AGENT_SUCCESS, response.data)
    } catch (error) {
      console.error(error)
      commit(FETCH_AGENT_FAILURE, error)
    }
  }

}

export default actions
